module.exports = __webpack_public_path__ + "img/soccer.ebabe49d.png";